// routes/mxManufacturerRoutes.tsx
import { Route, RouteObject } from 'react-router-dom';
import { MeterInventoryLanding } from './components/MeterInventoryLanding';
import { MeterDetailPage } from './components/MeterDetailPage';
import { AddMeterModelPage } from './components/AddMeterModelForm';
import { ManageManufacturersPage } from './components/ManageManufacturersPage';

export interface mxManufacturerRoute extends Omit<RouteObject, 'children'> {
  auth?: boolean;
  children?: mxManufacturerRoute[];
}

export const mxManufacturerRoutes: mxManufacturerRoute[] = [
  {
    path: 'mx/manufacturer',
    element: <MeterInventoryLanding />,
  },
  {
    path: 'mx/manufacturer/add',
    element: <AddMeterModelPage mode="add" />,
  },
  {
    path: 'mx/manufacturer/edit/:id',
    element: <AddMeterModelPage mode="edit" />,
  },
  {
    path: 'mx/manufacturer/view/:id',
    element: <MeterDetailPage/>,
  },
  {
    path: 'mx/manufacturer/manufacturers',
    element: <ManageManufacturersPage onBack={function (): void {} }/>,
  },
];